/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Highlights {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Highlights as HighlightsModule } from "@bw/modules"

const Highlights = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  point,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
        containerSize: point.length < 3 ? "small" : null,
      }}
    >
      <HighlightsModule points={point} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ...HighlightsModuleFragment
 *
 * This is also what you will get in the props of your Highlights
 * resolver component.
 */
export const query = graphql`
  fragment HighlightsModuleFragment on HighlightsModule {
    point {
      title
      description
      image {
        alt
        has_focus
        focus_css
        localImage {
          childImageSharp {
            gatsbyImageData(width: 350, height: 350)
          }
        }
      }
      linkType {
        value
      }
      url
      entry {
        url
      }
      isExternal
      openInModal
      linkText
    }
  }
`

export { Highlights }
